/* Sea Siren Gems: "Siren's tide" section. Pins the gallery and shifts through the products as you scroll; the shoreline video keeps looping behind. */
(function () {
  if (window.__sstInit) return;
  window.__sstInit = true;

  var root = document.documentElement;
  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!still) root.classList.add('sst-on');

  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }

  function init() {
    // Background videos only play while on screen, and not at all for reduced motion.
    document.querySelectorAll('.sst video').forEach(function (v) {
      v.muted = true;
      if (still) { v.removeAttribute('autoplay'); v.pause(); return; }
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
      }).observe(v);
    });
    if (still) return;

    var sec = document.querySelector('.sst--gallery[data-sst]');
    if (!sec) return;
    var cards = Array.prototype.slice.call(sec.querySelectorAll('.sst__card'));
    var thumbs = Array.prototype.slice.call(sec.querySelectorAll('.sst__thumb'));
    var n = cards.length;
    if (n < 2) return;
    var details = sec.querySelector('.sst__details');
    var f = {};
    ['index', 'name', 'sub', 'price', 'badge', 'cta'].forEach(function (k) { f[k] = details.querySelector('[data-sst-' + k + ']'); });
    sec.classList.add('is-live');

    var cur = 0, target = 0, active = -1, looping = false;

    function measure() {
      var r = sec.getBoundingClientRect();
      var total = sec.offsetHeight - window.innerHeight;
      var raw = (total > 0 ? clamp(-r.top / total, 0, 1) : 0) * (n - 1);
      // Each piece holds still for most of its stretch of scroll, then hands off quickly to the next.
      var i = Math.min(Math.floor(raw), n - 2), t = clamp((raw - i - 0.3) / 0.4, 0, 1);
      target = i + t * t * (3 - 2 * t);
    }

    function setActive(i) {
      if (i === active) return;
      active = i;
      var c = cards[i];
      details.classList.remove('is-swap');
      void details.offsetWidth;
      details.classList.add('is-swap');
      f.index.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
      f.name.textContent = c.dataset.name;
      f.sub.textContent = c.dataset.sub;
      f.price.textContent = c.dataset.price;
      f.badge.textContent = c.dataset.badge;
      f.cta.href = c.getAttribute('href');
      cards.forEach(function (k, j) { k.classList.toggle('is-active', j === i); });
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
      var t = thumbs[i];
      if (t && t.parentNode.scrollWidth > t.parentNode.clientWidth) {
        t.parentNode.scrollTo({ left: t.offsetLeft - t.parentNode.clientWidth / 2 + t.offsetWidth / 2, behavior: 'smooth' });
      }
    }

    function render() {
      var h = cards[0].offsetHeight;
      for (var i = 0; i < n; i++) {
        var d = i - cur, ad = Math.abs(d);
        var c = cards[i];
        // The next piece rises out of the water below; the last one drifts up and away.
        c.style.transform = 'translate(-50%, -50%) translate3d(' + (d * 18).toFixed(1) + 'px, ' + (d * h * 0.62).toFixed(1) + 'px, ' + (-ad * 140).toFixed(1) + 'px) rotateX(' + (-clamp(d, -1.5, 1.5) * 14).toFixed(2) + 'deg) scale(' + (1 - Math.min(ad, 2) * 0.1).toFixed(3) + ')';
        c.style.opacity = clamp(1 - ad * 1.6, 0, 1).toFixed(3);
        c.style.visibility = ad > 0.9 ? 'hidden' : 'visible';
        c.style.zIndex = String(100 - Math.round(ad * 10));
      }
      setActive(clamp(Math.round(cur), 0, n - 1));
    }

    function loop() {
      cur += (target - cur) * 0.1;
      if (Math.abs(target - cur) < 0.0008) cur = target;
      render();
      if (cur !== target) { requestAnimationFrame(loop); } else { looping = false; }
    }

    function onScroll() {
      measure();
      if (!looping) { looping = true; requestAnimationFrame(loop); }
    }

    function goTo(i) {
      var total = sec.offsetHeight - window.innerHeight;
      window.scrollTo({ top: window.scrollY + sec.getBoundingClientRect().top + (i / (n - 1)) * total + 1, behavior: 'smooth' });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { t.blur(); goTo(i); }); });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    measure();
    cur = target;
    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
